module.exports = "<svg id=\"cda6f4ca-4796-4956-a5cd-21ae005201fd\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49.49 23.25\"><title>arrow</title><path d=\"M45,14,27.92,27.66v-.1L25,29.95,22.09,27.6v.07L5,14a3.09,3.09,0,0,0-4.09.45,2.92,2.92,0,0,0,.45,4.09L23.19,36a2.66,2.66,0,0,0,1.82.64h0A4.3,4.3,0,0,0,26.83,36L48.66,18.52a2.93,2.93,0,0,0,.45-4.09A3,3,0,0,0,45,14Z\" transform=\"translate(-0.25 -13.38)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow.svg
// module id = 7Hhe
// module chunks = 2